import React from 'react';
import memoise from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Render from './render';
import Actions from '../../actions';
import { TAPIRequestCanceller } from '../../services/api';
import { trackView } from '../../services/analytics';
import { FETCH_STATIC_PAGES } from '../../constants/actions';
import { IStaticPage } from '../../definitions/static';
import { startingSlashIt } from '../../services/utils';

class StaticPage extends React.Component<any> {
  request: TAPIRequestCanceller;

  get location() {
    return this.props.location;
  }

  get pathname() {
    return this.location.pathname;
  }

  get pages() {
    return this.props.pages;
  }

  get page(): IStaticPage {
    return this.getStandardPage(this.pages, this.location.pathname);
  }

  get pageType() {
    return this.page.type === 'history'
      ? 'history'
      : 'standard';
  }

  get isStandardPage() {
    return this.pageType === 'standard';
  }

  get isHistoryPage() {
    return this.pageType === 'history';
  }

  get historyPages() {
    return this.getHistoryPages();
  }

  get standardPages(): IStaticPage {
    return this.page;
  }

  private getHistoryPages() {
    return this.pages.filter( ({ type, url }) => {
      return type === 'history';
    });
  }

  private getStandardPage = memoise((pages: IStaticPage[], path: string) => (
    pages.filter(({ url }) => `${startingSlashIt(url)}` === path)[0]
  ));

  fetchPage = () => {
    trackView(this.location.pathname);
    this.request = Actions.get(this.props.dispatch, FETCH_STATIC_PAGES);
  };

  componentDidMount() {
    this.fetchPage();
  }

  componentDidUpdate(pProps) {
    if (pProps.location.pathname !== this.location.pathname) {
      this.fetchPage();
    }
  }

  componentWillUnmount() {
    this.request.cancel('Static page unmounted');
  }

  render() {
    return Render.call(this, this.props, this.state);
  }
}

const state = ({ staticPages: { pages, pagination, error } }) => ({
  pages,
  pagination,
  error
});

export default withRouter(connect(state)(StaticPage));



// WEBPACK FOOTER //
// ./src/containers/StaticPage/index.tsx